import api, { apiErrorHandler } from "api";
import { DaNotificationsConstants } from "constants/constants";
import { RootState } from "reducers/rootReducer";
import { Dispatch } from "redux";
import { DaNotificationData } from "types/DaNotifications";

export const getNotifications = (user_id: number) => (dispatch: Dispatch) => {
  const onError = () => dispatch({ type: DaNotificationsConstants.DA_NOTIFICATIONS_ERROR });
  dispatch({ type: DaNotificationsConstants.DA_NOTIFICATIONS_LOADING });

  api
    .getNotificationList({ user: user_id })
    .then((res) => {
      if (res?.data) {
        dispatch({
          type: DaNotificationsConstants.DA_NOTIFICATIONS_SUCCESS,
          payload: res?.data.results,
        });
      }
    })
    .catch(apiErrorHandler(onError));
};

export const updateNotifications =
  (id: number, redirect: any) => (dispatch: Dispatch, getStore: () => RootState) => {
    const onError = () => dispatch({ type: DaNotificationsConstants.DA_NOTIFICATIONS_ERROR });
    dispatch({ type: DaNotificationsConstants.DA_NOTIFICATIONS_LOADING });

    const { notificationsList } = getStore()?.daNotificationsState;

    api
      .updateNotification(id, {
        is_read: true,
      })
      .then((res) => {
        if (res?.data) {
          const newData = notificationsList.map((item: DaNotificationData) =>
            item.id === id ? { ...item, is_read: true } : item,
          );
          dispatch({
            type: DaNotificationsConstants.DA_NOTIFICATIONS_SUCCESS,
            payload: newData,
          });
          redirect();
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const setNotificationsDrawerState = (data: boolean) => (dispatch: Dispatch) => {
  dispatch({
    type: DaNotificationsConstants.DA_NOTIFICATIONS_DRAWER_STATE,
    payload: data,
  });
};
